/**
 * Every language Speechmatics transcribes, for the pickers to label a code with.
 *
 * Which of these are actually OFFERED is a different question, answered by the
 * engine table and the environment (see `./engines.ts`) — this is only the
 * catalogue of names.
 *
 * Speechmatics calls four of its models "(Global)" to set them apart from the
 * regional variants it also sells. Redact carries none of those variants, so
 * the suffix told a user nothing and only made four of the fifty-odd entries
 * longer than the rest. Drop it here and every surface says "English". If a
 * regional variant is ever added, the suffix has to come back WITH it — at
 * that point it starts distinguishing something.
 */
export const availableSpeechmaticsLanguages = [
  { language: 'Arabic', code: 'ar' },
  { language: 'Bashkir', code: 'ba' },
  { language: 'Basque', code: 'eu' },
  { language: 'Belarusian', code: 'be' },
  { language: 'Bengali', code: 'bn' },
  { language: 'Bulgarian', code: 'bg' },
  { language: 'Cantonese', code: 'yue' },
  { language: 'Catalan', code: 'ca' },
  { language: 'Croatian', code: 'hr' },
  { language: 'Czech', code: 'cs' },
  { language: 'Danish', code: 'da' },
  { language: 'Dutch', code: 'nl' },
  { language: 'English', code: 'en' },
  { language: 'Esperanto', code: 'eo' },
  { language: 'Estonian', code: 'et' },
  { language: 'Finnish', code: 'fi' },
  { language: 'French', code: 'fr' },
  { language: 'Galician', code: 'gl' },
  { language: 'German', code: 'de' },
  { language: 'Greek', code: 'el' },
  { language: 'Hebrew', code: 'he' },
  { language: 'Hindi', code: 'hi' },
  { language: 'Hungarian', code: 'hu' },
  { language: 'Indonesian', code: 'id' },
  { language: 'Interlingua', code: 'ia' },
  { language: 'Irish', code: 'ga' },
  { language: 'Italian', code: 'it' },
  { language: 'Japanese', code: 'ja' },
  { language: 'Korean', code: 'ko' },
  { language: 'Latvian', code: 'lv' },
  { language: 'Lithuanian', code: 'lt' },
  { language: 'Malay', code: 'ms' },
  { language: 'Malay & English bilingual', code: 'en_ms' },
  { language: 'Maltese', code: 'mt' },
  { language: 'Mandarin', code: 'cmn' },
  { language: 'Mandarin & English bilingual', code: 'cmn_en' },
  { language: 'Marathi', code: 'mr' },
  { language: 'Mongolian', code: 'mn' },
  { language: 'Norwegian', code: 'no' },
  { language: 'Persian', code: 'fa' },
  { language: 'Polish', code: 'pl' },
  { language: 'Portuguese', code: 'pt' },
  { language: 'Romanian', code: 'ro' },
  { language: 'Russian', code: 'ru' },
  { language: 'Slovakian', code: 'sk' },
  { language: 'Slovenian', code: 'sl' },
  { language: 'Spanish', code: 'es' },
  { language: 'Swahili', code: 'sw' },
  { language: 'Swedish', code: 'sv' },
  { language: 'Tamil', code: 'ta' },
  { language: 'Tamil & English bilingual', code: 'en_ta' },
  { language: 'Thai', code: 'th' },
  { language: 'Turkish', code: 'tr' },
  { language: 'Ukrainian', code: 'uk' },
  { language: 'Urdu', code: 'ur' },
  { language: 'Uyghur', code: 'ug' },
  { language: 'Vietnamese', code: 'vi' },
  { language: 'Welsh', code: 'cy' },
];
